module.exports = __webpack_public_path__ + "media/images/default/cover-76a4f0c2929fd953b0b4f5f68af8a612.jpg";